import { render, staticRenderFns } from "./orgao.vue?vue&type=template&id=102922a4"
import script from "./orgao.vue?vue&type=script&lang=js"
export * from "./orgao.vue?vue&type=script&lang=js"
import style0 from "./orgao.vue?vue&type=style&index=0&id=102922a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports